import * as React from "react"
import { Chip, Box } from "@mui/material"

import { BadgeVariant, NotAllowedBlock } from "@components"
import { useUserApp } from "@hooks";



export default function stockStatusColumn(name, label, color, numVariants) {
	return {
		name: name, label: label,
		options: {
			customBodyRowRenderLite: (value, row) => <StockStatusCell
				value={value}
				row={row}
				color={color}
				numVariants={numVariants}
			/>
		}
	}
}

const StockStatusCell = ({ value, row, color, numVariants }) => {

	const { userGroupByProductID } = useUserApp()

	return <Box sx={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
		{!!value && <Chip label={value} sx={{ backgroundColor: row[color], mr: 1 }} />}
		{!value && <NotAllowedBlock />}
		{ !userGroupByProductID && row.showVariants && <BadgeVariant numVariants={row[numVariants]} /> }
	</Box>
}